import styled from 'styled-components';
import CancelledSvg from '../../assets/mytrips/cancelled.svg';

const CancelledIcon = styled(CancelledSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.2rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CancelledIcon;
